import { useState } from "react";
import { Play } from "lucide-react";
import { useReveal } from "../lib/useReveal";

export default function VideoSection() {
  const ref = useReveal();
  const [playing, setPlaying] = useState(false);
  return (
    <section
      data-testid="video-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">In motion</span>
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
            See <span className="italic text-[#1B4D3E]">compassion</span> in action.
          </h2>
        </div>

        <div className="relative rounded-3xl overflow-hidden border border-[#E3DECE] aspect-video bg-[#1A2E24]">
          {playing ? (
            <video
              className="absolute inset-0 w-full h-full object-cover"
              src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/r5oyj59m_WhatsApp%20Video%202026-04-25%20at%208.03.16%20PM.mp4"
              controls
              autoPlay
              playsInline
              poster="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/ld7h61jm_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM%20%282%29.jpeg"
            />
          ) : (
            <button
              onClick={() => setPlaying(true)}
              data-testid="video-play-btn"
              className="group w-full h-full relative"
              aria-label="Play our story film"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/ld7h61jm_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM%20%282%29.jpeg"
                alt="Play our story film"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-[900ms]"
              />
              <div className="absolute inset-0 bg-[#1A2E24]/50" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-24 h-24 md:w-28 md:h-28 rounded-full bg-[#D4AF37] flex items-center justify-center group-hover:scale-105 transition-transform">
                  <span className="absolute inset-0 rounded-full border border-[#D4AF37] scale-125 opacity-40 animate-ping" />
                  <Play className="w-10 h-10 text-[#1A2E24] fill-[#1A2E24] ml-1" />
                </div>
              </div>
              <div className="absolute left-6 bottom-6 text-left">
                <div className="text-[#D4AF37] text-[10px] tracking-[0.3em] uppercase">Our Story</div>
                <div className="font-display text-[#FDFBF7] text-2xl md:text-3xl mt-1">A day at Hastkesar</div>
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
